// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
  max-width: 600px;
}

.section h3 {
  margin: 0 0 4px 0;
  font-size: 16px;
  color: #1C72E8;
}

.section p {
  margin: 0 0 12px 0;
  font-size: 13px;
  color: #666;
}

`, "",{"version":3,"sources":["webpack://./src/examples/auxiliary/annotations/annotation-options/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding: 16px;\n  max-width: 600px;\n}\n\n.section h3 {\n  margin: 0 0 4px 0;\n  font-size: 16px;\n  color: #1C72E8;\n}\n\n.section p {\n  margin: 0 0 12px 0;\n  font-size: 13px;\n  color: #666;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container`,
	"section": `section`
};
export default ___CSS_LOADER_EXPORT___;
